import React from 'react';
import { capabilities } from '../data/site';
export function Capabilities() {
  const [lead, ...rest] = capabilities;
  return <section id="platform" aria-labelledby="platform-heading" className="border-t border-line" data-id="element-21" data-mp="2749lhyewux7y">
      <div className="mx-auto w-full max-w-[1440px] px-6 py-20 lg:px-16 lg:py-24" data-id="element-22" data-mp="2l3j1oy349rbx">
        <div className="max-w-[620px]" data-id="element-23" data-mp="2h4a57lgozfco">
          <h2 id="platform-heading" className="text-[32px] font-extrabold leading-tight tracking-tightest text-heading sm:text-[38px]" data-id="element-24" data-mp="2h14ek1sf05eu">
            One platform from the bus to the fleet
          </h2>
          <p className="mt-4 text-base leading-relaxed text-muted" data-id="element-25" data-mp="226hst26fz72p">
            Ziaxen runs inside the vehicle and above the fleet, so an anomaly on a single CAN
            segment is contained locally and understood centrally.
          </p>
        </div>

        <div className="mt-12 grid grid-cols-1 gap-px overflow-hidden rounded-2xl border border-line bg-line lg:grid-cols-3" data-id="element-26" data-mp="19nkk25tvhwz3">
          <article className="flex flex-col bg-canvas p-8 lg:col-span-2" data-id="element-27" data-mp="kq0etsdwxr6c">
            <p className="font-mono text-[44px] font-medium leading-none text-accent-ink" data-id="element-28" data-mp="knxmh1paflyg">
              {lead.metric}
            </p>
            <p className="mt-2 text-xs font-semibold uppercase tracking-[0.08em] text-subtle" data-id="element-29" data-mp="ufa3szdgmtq8">
              {lead.metricLabel}
            </p>
            <h3 className="mt-8 text-xl font-bold text-heading" data-id="element-30" data-mp="zedbkrktre1w">{lead.title}</h3>
            <p className="mt-3 max-w-[520px] text-sm leading-relaxed text-muted" data-id="element-31" data-mp="1s7k3ddg0nk1">
              {lead.description}
            </p>
          </article>

          <div className="grid grid-cols-1 gap-px bg-line" data-id="element-32" data-mp="6s28na9qx11x">
            {rest.map(item => <article key={item.id} className="flex flex-col bg-canvas p-8" data-id="element-33" data-mp="bronfo582pcu">
                <p className="font-mono text-2xl font-medium leading-none text-heading" data-id="element-34" data-mp="gpq82diaqwqf">
                  {item.metric}
                </p>
                <p className="mt-2 text-xs font-semibold uppercase tracking-[0.08em] text-subtle" data-id="element-35" data-mp="1s3bxlzs2j0ch">
                  {item.metricLabel}
                </p>
                <h3 className="mt-5 text-base font-bold text-heading" data-id="element-36" data-mp="3o4vrri1hbjky">{item.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-muted" data-id="element-37" data-mp="3j73x4g9g9jd2">{item.description}</p>
              </article>)}
          </div>
        </div>
      </div>
    </section>;
}